import { createBrowserClient } from "@supabase/ssr";

// Set the Supabase URL based on environment
const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;

if (!supabaseUrl) {
	throw new Error("Missing Supabase URL environment variable");
}

// Set the Supabase key based on environment
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseAnonKey) {
	throw new Error("Missing Supabase anon key environment variable");
}

// Create the Supabase client
const supabaseClient = createBrowserClient(supabaseUrl, supabaseAnonKey);

export const supabase = supabaseClient;
